var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"width":_vm.width,"height":_vm.height,"options":_vm.options,"series":_vm.parsedSeries}})
}
var staticRenderFns = []

export { render, staticRenderFns }